import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../Axios.jsx";
import DistrictDataGrid from "../../components/districtdatagrid/DistrictDataGrid";
import UsageStackedBar from "../../components/usagestackedbar/UsageStackedBar";
import useAuth from "../../contexts/UserContext.tsx";
import "./district.scss";
import { toast } from "sonner";

const Districts = (props) => {
  const { user, logout } = useAuth();

  const school_types = user.view_access_list.school_types
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  var school_type_array = school_types
    .replaceAll("'", "")
    .split(",")
    .sort()
    .map((school_type) => ({
      label: school_type,
      value: school_type,
    }));

  school_type_array = school_type_array.filter(
    (v, i, a) => a.findIndex((t) => t.value === v.value) === i
  );

  const media = useMediaQuery("(max-width: 768px)");
  const [districtsSummary, setDistrictsSummary] = useState([]);

  const [selectedSchoolTypes, setSelectedSchoolTypes] = useState(
    school_type_array.map((school_type) => school_type.value)
  );

  const getDistrictSummary = useCallback(async () => {
    try {
      const res = await axiosInstance.post("/getdistrictsummary", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_types,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setDistrictsSummary(
        res.data.data.district_summary.map((district) => ({
          ...district,
          center_count: parseInt(district.center_count),
          exercise_count: parseInt(district.exercise_count),
          school_count: parseInt(district.school_count),
          teacher_count: parseInt(district.teacher_count),
          tot_usage: parseInt(district.tot_usage),
          video_usage_count: parseInt(district.video_usage_count),
        }))
      );
    } catch (err) {
      alert(err.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user_id, user.auth_token, school_types]);

  const handleSubmitClick = async () => {
    const school_str = selectedSchoolTypes
      .map((school_type) => `'${school_type}'`)
      .join(",");

    try {
      const res = await axiosInstance.post("/getdistrictsummary", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_str,
      });
      setDistrictsSummary(res.data.data.district_summary);
    } catch (err) {
      alert(err.message);
    }
  };

  const handleSelectAllChange = () => {
    if (selectedSchoolTypes.length === school_type_array.length) {
      setSelectedSchoolTypes([]);
    } else {
      setSelectedSchoolTypes(
        school_type_array.map((school_type) => school_type.value)
      );
    }
  };

  useEffect(() => {
    getDistrictSummary();
  }, [getDistrictSummary]);

  return (
    <div className="districts">
      <div className="flex justify-around gap-2 mb-2">
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="School Types"
            value={selectedSchoolTypes}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      selectedSchoolTypes.length > 0 &&
                      selectedSchoolTypes.length < school_type_array.length
                    }
                    checked={
                      selectedSchoolTypes.length === school_type_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {school_type_array.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedSchoolTypes.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSchoolTypes([
                            ...selectedSchoolTypes,
                            option.value,
                          ]);
                        } else {
                          setSelectedSchoolTypes(
                            selectedSchoolTypes.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <button
          onClick={handleSubmitClick}
          className="bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
        >
          Submit
        </button>
      </div>

      {media ? null : <UsageStackedBar data={districtsSummary} />}
      {/* <SchoolTeacherBar/> */}
      <DistrictDataGrid data={districtsSummary} />
    </div>
  );
};

Districts.propTypes = {};

export default Districts;
